import { Contact } from '@eigtech/contacts-types'

export const getContactLicenseNumber = (contact: Partial<Contact> = {}, fallback = undefined) =>
  contact?.metadata?.licenseNumber ?? fallback
